import axios from 'axios'
import { identity, memoizeWith } from 'ramda'

declare const SI_API_URL: string

export const getGeoIP = memoizeWith(identity as any, () => {
  return axios
    .get(`${SI_API_URL}/geoip`, { timeout: 15 * 1000 })
    .then((resp) => resp.data)
    .then((geoCountry) => {
      if (geoCountry.status === 'fail') {
        return null
      }

      return geoCountry.countryCode
    })
    .catch(() => null)
})
